import React, { useState } from 'react';
import './PartnerLogin.css';

function PartnerLogin({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim(), password })
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || 'Login failed');
        setLoading(false);
        setTimeout(() => setError(''), 4000);
        return;
      }

      onLogin(data.token, data.user);
    } catch (err) {
      setError('Connection error. Please try again.');
      setLoading(false);
      setTimeout(() => setError(''), 4000);
    }
  };

  return (
    <div className="pv-login-page">
      <div className="pv-login-container">
        <div className="pv-login-header">
          <h1 className="pv-login-title">Finance Dashboard</h1>
          <p className="pv-login-subtitle">Sign in to continue</p>
        </div>

        <form onSubmit={handleSubmit} className="pv-login-form">
          {error && <div className="pv-login-error">{error}</div>}

          <div className="pv-login-field">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              autoFocus
            />
          </div>

          <div className="pv-login-field">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
            />
          </div>

          <button type="submit" className="pv-login-btn" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default PartnerLogin;
